export default "__VITE_ASSET__DxpAiCug__"